"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttorneyReviewStatusText = exports.LeadAttorneyStatusText = exports.DEFAULT_ROWS_PER_PAGE = exports.ExtensionsStaffHead = exports.ExtensionsAdminHead = exports.SharedAttorneyHeadMobile = exports.SharedAttorneyHead = exports.ReferralHead = exports.ArchivedHead = exports.ReviewAttorneyHead = exports.ReviewAdminHead = exports.AllHead = exports.ActiveClientsHead = exports.IntakeHeadHead = exports.LeadsTableType = void 0;
var LeadsTableType;
(function (LeadsTableType) {
    LeadsTableType["Intake"] = "Intake";
    LeadsTableType["ActiveClient"] = "ActiveClient";
})(LeadsTableType = exports.LeadsTableType || (exports.LeadsTableType = {}));
exports.IntakeHeadHead = [
    {
        id: "attorneyApprovalStatus",
        disablePadding: false,
        disableSorting: true,
        label: "Status",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "reviewingAttorneyName",
        disablePadding: false,
        label: "Reviewing attorney",
    },
    {
        id: "createdBy",
        disablePadding: false,
        label: "Created by",
    },
    {
        id: "createdAt",
        disablePadding: false,
        label: "Created at",
    },
    {
        id: "updatedAt",
        disablePadding: false,
        label: "Updated at",
    },
];
exports.ActiveClientsHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Stage",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "reviewingAttorney",
        disablePadding: false,
        label: "Reviewing attorney",
    },
    {
        id: "createdBy",
        disablePadding: false,
        label: "Created by",
    },
    {
        id: "createdAt",
        disablePadding: false,
        label: "Created at",
    },
    {
        id: "contractSentDate",
        disablePadding: false,
        label: "Contract sent",
    },
    {
        id: "supplementalAssignedName",
        disablePadding: false,
        label: "Supplemental Assigned",
    },
    {
        id: "updatedAt",
        disablePadding: false,
        label: "Updated at",
    },
];
exports.AllHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Stage",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "reviewingAttorney",
        disablePadding: false,
        label: "Reviewing attorney",
    },
    {
        id: "createdBy",
        disablePadding: false,
        label: "Created by",
    },
    {
        id: "createdAt",
        disablePadding: false,
        label: "Created at",
    },
];
exports.ReviewAdminHead = [
    {
        id: "attorneyApprovalStatus",
        disablePadding: false,
        label: "Status",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "createdBy",
        disablePadding: false,
        label: "Intake staff",
    },
    {
        id: "reviewingAttorneyName",
        disablePadding: false,
        label: "Reviewer attorney",
    },
    {
        id: "updatedAt",
        disablePadding: false,
        label: "Time from submission",
    },
];
exports.ReviewAttorneyHead = [
    {
        id: "attorneyApprovalStatus",
        disablePadding: false,
        label: "Status",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "updatedAt",
        disablePadding: false,
        label: "Updated at",
    },
];
exports.ArchivedHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Status",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "attorney",
        disablePadding: false,
        label: "Attorney",
    },
    {
        id: "archivedReason",
        disablePadding: false,
        label: "Archived reason",
    },
    {
        id: "createdAt",
        disablePadding: false,
        label: "Created at",
    },
];
exports.ReferralHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Stage",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "attorney",
        disablePadding: false,
        label: "Attorney",
    },
    {
        id: "createdBy",
        disablePadding: false,
        label: "Created by",
    },
    {
        id: "createdAt",
        disablePadding: false,
        label: "Created at",
    },
    {
        id: "updatedAt",
        disablePadding: false,
        label: "Updated at",
    },
];
exports.SharedAttorneyHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Stage",
    },
    {
        id: "leadName",
        disablePadding: false,
        label: "Lead name",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
    {
        id: "updatedAt",
        disablePadding: false,
        label: "Updated at",
    },
];
exports.SharedAttorneyHeadMobile = [
    {
        id: "status",
        disablePadding: false,
        label: "Stage",
    },
    {
        id: "category",
        disablePadding: false,
        label: "Category",
    },
];
exports.ExtensionsAdminHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Status",
    },
    {
        id: "requestedByName",
        disablePadding: false,
        disableSorting: true,
        label: "By",
    },
    {
        id: "totalOverdue",
        disablePadding: false,
        label: "Days over due",
    },
    {
        id: "taskName",
        disablePadding: false,
        label: "Task",
    },
    {
        id: "materName",
        disablePadding: false,
        label: "Matter",
    },
    {
        id: "currentDueDate",
        disablePadding: false,
        label: "Initial Due Date",
    },
    {
        id: "requestedDueDate",
        disablePadding: false,
        label: "Requested Due Date",
    },
    {
        id: "updatedDueDate",
        disablePadding: false,
        label: "Clio Due Date",
    },
    {
        id: "requestMessage",
        disablePadding: false,
        label: "Message",
    },
];
exports.ExtensionsStaffHead = [
    {
        id: "status",
        disablePadding: false,
        label: "Status",
    },
    {
        id: "taskName",
        disablePadding: false,
        label: "Task",
    },
    {
        id: "materName",
        disablePadding: false,
        label: "Matter",
    },
    {
        id: "currentDueDate",
        disablePadding: false,
        label: "Initial Due Date",
    },
    {
        id: "requestedDueDate",
        disablePadding: false,
        label: "Requested Due Date",
    },
    {
        id: "updatedDueDate",
        disablePadding: false,
        label: "Clio Due Date",
    },
    {
        id: "adminMessage",
        disablePadding: false,
        label: "Message",
    },
];
exports.DEFAULT_ROWS_PER_PAGE = 10;
var LeadAttorneyStatusText;
(function (LeadAttorneyStatusText) {
    LeadAttorneyStatusText["IN_PROCESS"] = "Need attorney approval";
    LeadAttorneyStatusText["REFER"] = "Ready to refer";
    LeadAttorneyStatusText["MORE_INFO_PROVIDED"] = "Additional info provided";
    LeadAttorneyStatusText["MORE_INFO_REQUESTED"] = "Need additional info";
})(LeadAttorneyStatusText = exports.LeadAttorneyStatusText || (exports.LeadAttorneyStatusText = {}));
var AttorneyReviewStatusText;
(function (AttorneyReviewStatusText) {
    AttorneyReviewStatusText["IN_PROCESS"] = "Approval requested";
    AttorneyReviewStatusText["MORE_INFO_PROVIDED"] = "Additional info provided";
    AttorneyReviewStatusText["MORE_INFO_REQUESTED"] = "Need additional info";
})(AttorneyReviewStatusText = exports.AttorneyReviewStatusText || (exports.AttorneyReviewStatusText = {}));
//# sourceMappingURL=LeadsTableConstants.js.map